import React from 'react';
import './Home.css';
import photo from '../../assets/images/photo.png';
import Testimonials from '../../components/testimonials/Testimonials.tsx';
import SEO from '../../components/SEO/SEO.tsx';
import StructuredData from '../../components/SEO/StructuredData.tsx';

const services = [
  { title: 'Airport Car Service', desc: 'Reliable rides to PHL, EWR, and JFK from Bucks County and greater Philadelphia. No surge pricing, no surprises.' },
  { title: 'Corporate & Events', desc: 'Professional car service for business travel, galas, and group outings across the Philadelphia suburbs.' },
  { title: 'Hourly Chauffeur', desc: 'Private driver by the hour for meetings, errands, medical appointments, or a night out in Philadelphia.' },
  { title: 'Long-Distance Rides', desc: 'Comfortable point-to-point car service from Bucks County to anywhere in the tri-state region.' },
];

const Home: React.FC = () => {
  return (
    <>
      <SEO
        title="Bucks County Car Service & Airport Rides | CABnHAUL"
        description="CABnHAUL provides private car service in Bucks County, PA and greater Philadelphia. Airport rides to PHL, EWR & JFK, corporate transportation, and hourly chauffeur service. Local, reliable driver — call (215) 384-3448."
        keywords="Bucks County car service, airport car service Bucks County, private car service Bucks County PA, ride to PHL airport from Bucks County, car service Yardley PA, car service Newtown PA, car service Langhorne PA, Philadelphia airport transportation, private driver Bucks County, executive car service Philadelphia suburbs, car service from Doylestown to PHL, Bucks County to Philadelphia airport, CABnHAUL"
        url="https://cabnhaul.com"
        type="website"
      />
      <StructuredData type="LocalBusiness" />

      <div className="home-page">
        <section className="hero-section" aria-label="Hero">
          <img
            src={photo}
            alt="CABnHAUL Premier Transportation Service"
            className="home-image"
          />
          <div className="hero-scrim" aria-hidden="true" />
          <div className="hero-overlay">
            <div className="hero-content">
              <span className="service-area-chip">Serving Bucks County &amp; Greater Philadelphia</span>
              <h1 className="hero-title">Personalized Premier Transportation</h1>
              <p className="hero-subtitle">Reliable, Professional, Local Service You Can Trust</p>
              <div className="hero-cta-row">
                <a href="/contact" className="hero-cta-primary">Get a Quote</a>
                <a href="tel:+12153843448" className="hero-cta-phone">or call (215) 384-3448</a>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="services-strip" aria-label="Services">
          <h2 className="services-title">Our Services</h2>
          <div className="services-grid">
            {services.map((s) => (
              <div key={s.title} className="service-card">
                <h3 className="service-card-title">{s.title}</h3>
                <p className="service-card-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <div id="testimonials">
          <Testimonials />
        </div>
      </div>
    </>
  );
};

export default Home;
